import { customToast } from "../../../../shared";
import { activityLogsService } from "../../services";
import { success, withSpinner } from "../../../../redux/actions/utilities";
import {
  activityLogsConstants,
  toastTypes,
} from "../../constants";

const { FETCH_ACTIVITY_LOGS } = activityLogsConstants;

//Fetching activity logs paginated data
const getActivityLogs = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, FETCH_ACTIVITY_LOGS, () =>
      activityLogsService
        .getActivityLogs(body)
        .then(
          (response) => {
            dispatch(success(response, FETCH_ACTIVITY_LOGS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

export const activityLogsActions = {
  getActivityLogs,
};
